<div class="wrapper">
	<ion-icon src="../../../assets/topgolf/info.svg"></ion-icon>
	<h3>
		{{ 'add_promo_dialog.error_promo.title' | translate }}
	</h3>
	<p></p>
	<ion-button (click)="close()">
		{{ 'add_promo_dialog.error_promo.button' | translate }}
	</ion-button>
	@if (showDisableButton) {
		<ion-button (click)="withoutPromo()" class="without_promo">
			{{ 'add_promo_dialog.error_promo.without_promo' | translate }}
		</ion-button>
	}
</div>
